import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from "../security.module.config";
import { DeleteRoleModel } from "../models/DeleteRoleModel";
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as fromStore from '../store/reducers';

import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { RoleListModel } from '../models/RoleListModel';
import { RoleModel } from '../models/RoleModel';


@Component({
  selector: 'brd-delete-role-confirmation-dialog',
  templateUrl: './delete-role-confirmation-dialog.component.html',
  styleUrls: ['./delete-role-confirmation-dialog.component.scss']
})
export class DeleteRoleConfirmationDialogComponent implements OnInit, OnDestroy {
  eventUnsubscribe: Subscription;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  name: string;
  key: string;
  deleteActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  constructor(
    public dialogRef: MatDialogRef<DeleteRoleModel>,
    private router: Router,
    private actions$: Actions,
    private store: Store<TileState<RoleListModel, RoleModel>>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteRoleModel) {
    this.name = data.name;
    this.key = data.key;
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.deleteSuccessType<DeleteRoleModel>(ModuleConfiguration.moduleName, DeleteRoleModel))
      .subscribe((a: actions.DeleteSuccessAction<DeleteRoleModel>) => {
        this.store.dispatch(new actions.QueryListAction(ModuleConfiguration.moduleName,
          RoleListModel,
          {
            page: 0,
            pageSize: 20,
          }));
        this.router.navigateByUrl('/administration');

        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.deleteActionIdentifier && a.payload.action.identifier === this.deleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }
  delete() {
    var model = this.data;
    var deleteAction = new actions.DeleteAction(ModuleConfiguration.moduleName, DeleteRoleModel, { model: model });
    this.deleteActionIdentifier = deleteAction.identifier;
    this.store.dispatch(deleteAction);
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/security/components/delete-role-confirmation-dialog.component.ts